var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { APP_STORE } from '@/stores/defs';
var featureFlags = {
    computed: __assign({}, mapGetters({
        getFeatureFlag: APP_STORE.GET_FEATURE,
    })),
    methods: __assign({}, mapActions({
        setFeatureFlag: APP_STORE.SET_FEATURE,
    }), { checkForFeature: function (name) {
            // @ts-ignore
            var hasFeature = !!this.getFeatureFlag(name);
            return hasFeature;
        } }),
};
export default featureFlags;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/featureMixin.ts
// module id = BNIk
// module chunks = 18